export class telecom {
  system: 'phone' | 'mobile' | 'email' | 'url';
  value: string;
  use: string;
  constructor(system: 'phone' | 'mobile' | 'email' | 'url', value: string, use: string) {
    this.system = system;
    this.value = value;
    this.use = use;
  }
}

export class identifier {
  system: 'CNPJ' | 'CPF' | 'CRM';
  value: string;
  constructor(system: 'CNPJ' | 'CPF' | 'CRM', value: string) {
    this.system = system;
    this.value = value;
  }
}

class hoursOfOperation {
  closingTime: string;
  openingTime: string;
  allDay: boolean;
  daysOfWeek: Array<any>;
  constructor(openingTime: string, closingTime: string, allDay: boolean, daysOfWeek: Array<[]>) {
    this.closingTime = closingTime;
    this.openingTime = openingTime;
    this.allDay = allDay;
    this.daysOfWeek = daysOfWeek;
  }
}

class position {
  longitude: number;
  latitude: number;
  altitude: number;
  constructor(longitude: number, latitude: number, altitude: number) {
    this.longitude = longitude;
    this.latitude = latitude;
    this.altitude = altitude;
  }
}

export default class Organization {
  organization_id?: string | number;
  name: string;
  alias?: string;
  active: Boolean;
  cnpj?: string;
  legal_representative?: string;
  token_id?: string;

  constructor(organization_id: string, name: string, alias: string, active: Boolean, cnpj: string, token_id?: string) {
    this.name = name;
    this.alias = alias;
    this.active = active;
    this.cnpj = cnpj;
    this.organization_id = organization_id;
    this.token_id = token_id;
  }
}
